import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () =>
        import(/* webpackChunkName: "homepage" */ './views/Home.vue'),
    },
    {
      path: '/feedback',
      name: 'feedback',
      component: () =>
        import(/* webpackChunkName: "feedback" */ './views/Feedback.vue'),
    },
    {
      path: '/guide',
      name: 'guide',
      component: () =>
        import(/* webpackChunkName: "guide" */ './views/Guide.vue'),
    },
    {
      path: '/user/:username/shelf/:shelflabel',
      name: 'shelf',
      component: () =>
        import(/* webpackChunkName: "shelf" */ './views/Shelf.vue'),
    },
    {
      path: '/author/:guid',
      name: 'author',
      component: () =>
        import(/* webpackChunkName: "author" */ './views/Author.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue'),
    },
    {
      path: '/logout',
      name: 'logout',
      component: () =>
        import(/* webpackChunkName: "logout" */ './views/Logout.vue'),
    },
    {
      path: '/user/:username?',
      name: 'user',
      component: () =>
        import(/* webpackChunkName: "user" */ './views/User.vue'),
    },
    {
      path: '/add-book',
      name: 'create',
      component: () =>
        import(/* webpackChunkName: "create" */ './views/Create.vue'),
    },
    {
      path: '/scan-book',
      name: 'scan',
      component: () =>
        import(/* webpackChunkName: "scan" */ './views/Scan.vue'),
    },
    {
      path: '/add-shelf',
      name: 'addShelf',
      component: () =>
        import(/* webpackChunkName: "addShelf" */ './views/AddShelf.vue'),
    },
  ],
});
